// frontend/src/services/categoryService.js

import api from './apiService';

const BASE_URL = 'financeiro/categorias/';

/**
 * Busca a lista de todas as categorias do usuário.
 */
export const getCategorias = async () => {
    const response = await api.get(BASE_URL);
    return response.data;
};

/**
 * Cria uma nova categoria.
 * @param {object} categoriaData - Os dados da nova categoria.
 */
export const createCategoria = async (categoriaData) => {
    const response = await api.post(BASE_URL, categoriaData);
    return response.data;
};

/**
 * Atualiza uma categoria existente.
 * @param {number} id - O ID da categoria a ser atualizada.
 * @param {object} categoriaData - Os novos dados da categoria.
 */
export const updateCategoria = async (id, categoriaData) => {
    const response = await api.put(`${BASE_URL}${id}/`, categoriaData);
    return response.data;
};

/**
 * Deleta uma categoria.
 * @param {number} id - O ID da categoria a ser deletada.
 */
export const deleteCategoria = async (id) => {
    await api.delete(`${BASE_URL}${id}/`);
};
